export const LOGIN_SUCCESS = "header/loginsuccess";
export const LOGIN_FAILED = "header/loginfailed";
export const SET_ACCOUNT_NAME = "header/SET_ACCOUNT_NAME";
export const SET_DUE_PROJECT = "header/SET_DUE_PROJECT";
export const SET_DATA = "headers/SET_DATA";
export const SET_NOTICE_DATA = "headers/SET_NOTICE_DATA";
export const SET_UP_PROCESS = "headers/SET_UP_PROCESS";
export const SET_IMU_DATA = "headers/SET_IMU_DATA";
export const SET_INTEGRATION_LOGS = "headers/SET_INTEGRATION_LOGS";
export const SET_SUBSCRIPTION_NOTICE = "headers/SET_SUBSCRIPTION_NOTICE";
export const SET_INTEGRATION_ERROR = "headers/SET_INTEGRATION_ERROR";
